import React from 'react';
import UsersList from '../../components/callcenter/UsersList';

const CallcenterUsersPage = () => {
  return <UsersList />;
};

export default CallcenterUsersPage;

